<template>
  <div class="home pb-3xl">
    

    <!--////////////////////////////  POPUP LAYER //////////////////////////////////////////////// -->
    <!-- v-if="needPopup" -->
    
    <div class="ppLayer" v-if="needPopup">
      <div class="ppInner">      
        <div class="ppTitle">Maintenance of IT system</div>
        <div class="ppContent">   
          Starting from <b>April 4th 18:00</b> new orders for MGUIDE will be blocked from our production system. 
          They will be started up again <b>April 7th 8:00</b>          
          <br/><br/>Please try to place your orders <b class="ubold">before April 4th</b>. 
          <br/>We apologize for the inconvenience and thank you for understanding.
          <br/><br/><br/>
          <a class="ppBtn ml-s" @click="hideStartupPopup"><span>OK</span></a>          
        </div>
      </div>
    </div>
    
    <!--////////////////////////////  POPUP LAYER //////////////////////////////////////////////// -->
    <!-- <br/><br/>You can place orders during the maintenance but will not receive confirmation email until April 7th. -->



    <div>
      <filter-bar></filter-bar>
    </div>
    <infobar></infobar>
    <template v-if="!isMcenter">
      <data-table @reload="reloadList" :list="filteredOrdersByType"></data-table>
    </template>
    <template v-else>
      <div class="mb-2xl">
        <h5 :class="['mb-s', $device === 'mobile' ? 'mx-2xl' : 'mx-3xl']">
          NEW ORDERS
        </h5>
        <data-table class="short" :list="newOrders"></data-table>
      </div>
      <div>
        <h5 :class="['mb-s', $device === 'mobile' ? 'mx-2xl' : 'mx-3xl']">
          ORDERS IN PROCESS
        </h5>
        <data-table @reload="reloadList" class="short" :list="activeOrders"></data-table>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
// temp
import { test_data } from "@/data";

import FilterBar from "@/components/FilterBar.vue";
import Infobar from "@/components/Infobar.vue";
import DataTable from "@/components/DataTable.vue";
export default {
  name: "Home",
  data() {
    return {
      testData: test_data
    };
  },
  components: {
    FilterBar,
    Infobar,
    DataTable
  },
  mounted()
  {
    //alert("this.showStartupPopup="+this.showStartupPopup);
  },
  methods:
  {
    ...mapActions(["initOrdersList","hideStartupPopup"]),
    reloadList()
    {
      this.initOrdersList();
    }
  },
  computed: 
  {
    ...mapState(["$device","showStartupPopup","user"]),
    ...mapGetters(["isMcenter","isDistributor","userType","filteredOrdersByType"]),
    newOrders() {
      return _.filter(this.filteredOrdersByType, { StatusID: 1 });
    },
    activeOrders() {
      return _.filter(this.filteredOrdersByType, order => order.StatusID !== 1);
    },
    needPopup()
    {
      return false;
      //this.user.IsPwsUser==true
      if(this.showStartupPopup && this.user.McenterID == 9){
        return true;
      }else{
        return false;
      }      
    }
  }
};
</script>

<style>
  .ppLayer
  {
    position: fixed;
    z-index: 10000;
    top: 10px;
    left: 0px;
    width: 100%;
    height: 100vh;
    background-color: rgba(255,255,255,0.6);
    display: flex;
    align-items: center;
  }
  .ppInner
  {
    width: 40vw;
    height: auto;
    background-color: #1971ae;
    margin: auto;
    border-radius: 20px;
    padding: 3vw;
  }
  .ppTitle{
    color: #fff;
    font-size: 24px;
    font-weight: 500 !important;
  } 
  .ppContent
  {
    padding-top:18px;
    color: #fff;
    font-size: 16px;
  }
  .ppContent b
  {
    font-weight: 500 !important;
  }
  .ppContent .ubold
  {
    text-decoration: underline;
  }
  .ppBtn
  {
      border:1px solid white;
      border-radius:34px;
      padding:6px 20px;
      transition: all 0.2s ease-out;
      float: right;
      cursor: pointer;
  }
  .ppBtn span
  {
      font-size:14px;
      font-weight:400 !important;
      color:#fff;    
  }
  .ppBtn:hover
  {
      background:#fff;
      color:#1971ae;
  }



</style>

<style lang="stylus" scoped>
.home
  position relative
  // min-height 2000px
.btn-neworder
  position relative
  z-index 9
  background green_6
  float right
  _flex(row, nowrap, center, center)
  line-height 1
  height 80px
  width 200px
  font-size 18px
  font-weight 300
  i
    font-size 22px
  *
    color #fff
    opacity 0.88
    transition opacity 0.3s ease-out
  +desktop()
    &:hover
      *
        opacity 1
</style>
